import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

@Injectable()
export class ClientReviewService {

    constructor(
        private request: ObservableRequestService
    ) { }

    getAccountManagerInformation(): Observable<any> {
        return this.request.getRequest(ConstantsService.CLIENT_REVIEWS_ENDPOINT);
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/reviews/client-review.service.ts